/**
 * @author varun
 */
/**
 * Commond directive which will be used for the select2 jquery plugin. 
 * Binds the ngmodel of the element with the select2 plugin.
 */
angular.module('AppCtrl.Tasks.directive', ['jv.Common.Filters', 'jv.services']).
directive('jvDateNgmodel', ['$filter', function ($filter) {
	return {
		require: '?ngModel',
		restrict: 'A',
		link: function (scope, element, attr, ngModel) {
			if (!ngModel) {
				return;
			}

			// Called when the view needs to be updated.
			ngModel.$render = function () {
				element.val(ngModel.$viewValue);
			};

			$(element).bind('change', function () {
				scope.$apply(setValue);
			});

			//sets the value of the ng-model
			function setValue() {
				ngModel.$setViewValue(element.val());
			}
		}
	};
}])
/**
 * An angular date picker directive.
 */
.directive('jvDatePicker', ['$compile', '$filter', 'currentUserService', function ($compile, $filter, currentUserService) {
	var directiveObj = {
		restrict: 'A',
		replace: true,
		template: '<div>' + "<input jv-date-ngmodel type=' text ' style='width: 200 px; max-width: 200 px;'  />" + '</div>',
		compile: function (tElement, tAttrs, transclude) {
			return {
				pre: function (scope, element, attrs, controller) {
					var childElement = angular.element(element.children()[0]);
					// add the parent scope or the isolated scope.
					angular.element(childElement).attr('ng-model', !!attrs.ngModelparentRef ? attrs.ngModelparentRef : attrs.ngModelRef);
					//scope.entity.dueDate = $filter('date')(new Date(scope.entity.dueDate), 'MM/dd/yyyy');
					scope.$watch('entity', function (newValue, oldValue) {
						if (angular.isDefined(scope.entity)) {
							// [DO NOT LOCALIZE] This date should not be filtered into a different date format.
							// The formatting will be handled by the dateFormat option for the date picker below.
							scope.entity.dueDate = scope.entity.dueDate;
						}
					}, true);
				},
				post: function (scope, element, attrs, controller) {
					var childElement = angular.element(element.children()[0]);
					var options = {

						// Change the display format to use the users chosen date format
						dateFormat: currentUserService.locale.userDate.shortDatePicker() || 'mm/dd/yy'
					};

					$(childElement).datepicker(options);
					$compile(element.contents())(scope);
				}
			};
		}
	}
	return directiveObj;
}]);